import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const ContentMyConferences = styled.div`
  width: 100%;
  margin: 0px auto;
  height: 52px;
  padding: 0px 14px;
  color: #656a6e;
  display: flex;
  margin-top: 19px;
  align-items: center;
  justify-content: space-between;
`;

export const List = styled.div`
  width: 100%;
  margin-top: 14px;
`;
